import { render } from "./Category_Product_Modal.vue?vue&type=template&id=f1c1f974"
import script from "./Category_Product_Modal.vue?vue&type=script&lang=js"
export * from "./Category_Product_Modal.vue?vue&type=script&lang=js"

import "./Category_Product_Modal.vue?vue&type=style&index=0&id=f1c1f974&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__